<div
  class="flex items-center justify-center w-full transition-all duration-300 overflow-hidden"
>
  <img
    src="brand/logo-simples.png"
    [alt]="brandConfig.appName"
    class="h-8 w-auto flex-shrink-0"
  />
</div>
